// LanguageContext.js
import i18n from "../i18n";
import { createContext, useState, useContext, useEffect } from "react";

export const LanguageContext = createContext();

export const useLanguageContext = () => useContext(LanguageContext);

// eslint-disable-next-line react/prop-types
export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(i18n.language);

  useEffect(() => {
    // Đồng bộ ngay lập tức khi mount
    setLanguage(i18n.language);

    const handleLanguageChange = (lang) => {
      setLanguage(lang);
    };

    i18n.on("languageChanged", handleLanguageChange);

    return () => {
      i18n.off("languageChanged", handleLanguageChange);
    };
  }, []);

  // Hàm thay đổi ngôn ngữ
  const changeLanguage = async (lang) => {
    await i18n.changeLanguage(lang);
    setLanguage(lang); // Cập nhật ngôn ngữ trong context
  };

  return (
    <LanguageContext.Provider value={{ language, changeLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};
